import { FC, type ReactNode } from 'react'

import CloseIcon from '@mui/icons-material/Close'
import {
  Avatar,
  Dialog,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material'

import Decimal from 'decimal.js'
import { format } from '@/utils/number-helpers'

type BaseDialogParams = {
  title?: string
  tokenAvatar?: string
  tokenSymbol?: string
  titleAmount?: number
  body: ReactNode
  isOpened?: boolean
  handleClose: () => void
  className?: string
}
const BaseDialog: FC<BaseDialogParams> = ({
  title,
  tokenAvatar,
  tokenSymbol,
  titleAmount,
  body,
  isOpened,
  handleClose,
  ...dialogProps
}) => {
  return (
    <Dialog
      {...dialogProps}
      open={!!isOpened}
      onClose={handleClose}
      PaperProps={{
        className: 'rounded-2xl bg-popup-gradient w-[480px] min-w-[374px]',
        style: {
          border: '1px solid #FFFFFF1F',
        },
      }}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
    >
      <Stack className="p-4 lg:p-6">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          {title ? (
            <Typography className="font-cc text-white uppercase text-sm sm:text-base" sx={{ wordSpacing: '0.4rem' }}>
              {title}
            </Typography>
          ) : (
            <Stack className="flex flex-row gap-4">
              <Avatar
                src={tokenAvatar}
                alt={tokenSymbol}
                sx={{
                  width: { xs: 48, lg: 64 },
                  height: { xs: 48, lg: 64 },
                }}
              />
              <Stack>
                <Typography className="font-dm_mono_regular text-xs-2 sm:text-sm md:text-base text-semi-transparent-white">
                  {tokenSymbol}
                </Typography>
                <Typography className="font-zen_dot text-base sm:text-lg-2 md:text-2xl text-white">
                  {`${format(new Decimal(titleAmount || 0), true, 2)}`}
                </Typography>
              </Stack>
            </Stack>
          )}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
              alignSelf: 'flex-start',
            }}
          >
            <CloseIcon className='h-4 w-4 md:h-6 md:w-6'/>
          </IconButton>
        </Stack>
        <Divider
          className="mt-5 w-full"
          style={{
            height: '2px',
            backgroundColor: 'rgba(220, 193, 255, 0.08)',
          }}
        />
        <Stack className="mt-5">{body}</Stack>
      </Stack>
    </Dialog>
  )
}

export default BaseDialog
